import React from 'react';
import { Box } from '@cp/ds/src/components/box';
import { Tooltip } from '@cp/ds/src/components/tooltip';
import { InfoIcon } from '@cp/ds/src/icons';
import { Switch } from '@cp/ds/src/components/switch';
import { mergeSx } from '@cp/ds/src/utils/sx/merge';
import { getClientIsWorkingContent } from '../model';
import { ClientWorkingProps } from './model';

export * from './model';

export const ClientWorking: React.FC<ClientWorkingProps> = ({ isWorking, onChange, sx }) => {
  const content = getClientIsWorkingContent(isWorking);

  return (
    <Box sx={mergeSx({ display: 'inline-flex', alignItems: 'center' }, sx)}>
      <Switch onChange={onChange} sx={{ mr: 1 }} value={isWorking} />

      <span style={{ whiteSpace: 'nowrap' }}>{content.label}</span>

      <Tooltip
        arrow
        colorSchema="dark"
        title={
          <Box component="span" sx={{ display: 'inline-block', px: 1.5, py: 1 }}>
            {content.tooltipText}
          </Box>
        }
      >
        <Box component="span" sx={{ p: 0.5, my: -0.5, color: 'gray', display: 'inline-flex' }}>
          <InfoIcon fontSize="1.125rem" />
        </Box>
      </Tooltip>
    </Box>
  );
};
